import { t } from 'i18next';

export const PATIENT_KEY = 'patient_filters';
export const USER_KEY = 'user-filters';
export const INTITUTION_TYPES = {
	BIOBANK: 'BioBanco',
};

export const dxSubtypes_OPTIONS = [
	{ value: 'confirm', label: 'A confirmar' },
	{ value: 'AML', label: 'AML' },
	{ value: 'AML M0', label: 'AML M0' },
	{ value: 'AML M1', label: 'AML M1' },
	{ value: 'AML M2', label: 'AML M2' },
	{ value: 'AML M3', label: 'AML M3' },
	{ value: 'AML M4', label: 'AML M4' },
	{ value: 'AML M5', label: 'AML M5' },
	{ value: 'AML M6', label: 'AML M6' },
	{ value: 'AML M7', label: 'AML M7' },
	{ value: 'ALL', label: 'ALL' },
	{ value: 'ALL-B', label: 'ALL-B' },
	{ value: 'ALL-T', label: 'ALL-T' },
	{ value: 'Other', label: t('other') },
];
export const dxSecondary_OPTIONS = [
	{ value: 'Inicial', label: t('initial') },
	{ value: 'Secundario', label: t('secondary') },
];
export const sex_OPTIONS = [
	{ value: 'male', label: t('male') },
	{ value: 'female', label: t('female') },
];
export const riskLevel_OPTIONS = [
	{ value: 'N/A', label: 'N/A' },
	{ value: 'N/R', label: 'N/R' },
	{ value: 'Bajo', label: 'Bajo' },
	{ value: 'Medio', label: 'Medio' },
	{ value: 'Alto', label: 'Alto' },
];
export const yesOrNo_OPTIONS = [
	{ value: true, label: t('yes') },
	{ value: false, label: t('no') },
];
export const samples_OPTIONS = [
	{ value: 'MO', label: 'MO' },
	{ value: 'SP', label: 'SP' },
	{ value: 'MO + SP', label: 'MO + SP' },
];
export const institutionsType_OPTIONS = [
	{ value: 'Laboratorio', label: t('laboratory') },
	{ value: 'Fundación', label: 'Fundación' },
	{ value: 'Hospital', label: 'Hospital' },
	{ value: 'BioBanco', label: t('bioBank') },
];
export const diseaseAssessment_OPTIONS = [
	{ value: 'RC', label: 'RC' },
	{ value: 'RP', label: 'RP' },
	{ value: 'NE', label: 'NE' },
	{ value: 'NR', label: 'NR' },
];
export const fitOrUnfit_OPTIONS = [
	{ value: 'Fit', label: 'Fit' },
	{ value: 'Unfit', label: 'Unfit' },
];
export const scheme_OPTIONS = [
	{ value: '7+3 (AraC + IDA)', label: '7+3 (AraC + IDA)' },
	{ value: '7+3 (AraC + DNR)', label: '7+3 (AraC + DNR)' },
	{ value: '7+3 (AraC + IDA + MIDO)', label: '7+3 (AraC + IDA + MIDO)' },
	{ value: '7+3 (AraC + DNR + MIDO)', label: '7+3 (AraC + DNR + MIDO)' },
	{ value: '7+3 (AraC + MTT)', label: '7+3 (AraC + MTT)' },
	{ value: 'Venetoclax + Azacitidina', label: 'Venetoclax + Azacitidina' },
	{ value: 'Azacitidina', label: 'Azacitidina' },
	{ value: 'Decitabina', label: 'Decitabina' },
	{
		value: 'Venetoclax + Ara-C (Bajas dosis)',
		label: 'Venetoclax + Ara-C (Bajas dosis)',
	},
	{ value: 'FLAG-Ida', label: 'FLAG-Ida' },
	{ value: 'CLAG-IDA', label: 'CLAG-IDA' },
	{
		value: 'etopósido + citarabina + mitoxantrona',
		label: 'etopósido + citarabina + mitoxantrona',
	},
	{ value: 'Ara-C (Bajas dosis)', label: 'Ara-C (Bajas dosis)' },
	{ value: 'Protocolos tipo BFM', label: 'Protocolos tipo BFM' },
	{ value: 'GATLA2017', label: 'GATLA2017' },
	{ value: 'GATLA 2019 pacientes AYA', label: 'GATLA 2019 pacientes AYA' },
	{
		value: 'GATLA 2019 pacientes adultos',
		label: 'GATLA 2019 pacientes adultos',
	},
	{
		value: 'GATLA 2019 pacientes >60 años',
		label: 'GATLA 2019 pacientes >60 años',
	},
	{ value: 'HyperCVAD', label: 'HyperCVAD' },
	{ value: 'HyperCVAD-AD MTX-AraC', label: 'HyperCVAD-AD MTX-AraC' },
	{ value: 'AloTCHP', label: 'AloTCHP' },
	{ value: 'AutoTCPH', label: 'AutoTCPH' },
	{ value: 'Other', label: t('other') },
];
